export default __webpack_public_path__ + "static/media/feather _ phone.6b14e638.svg";